export default __webpack_public_path__ + "4270f937783123d9d5c93ecdc512da99.gif";